// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(ElementUI);
import store from './store/index.js' // 引入vuex
Vue.prototype.$store = store // 定义成全局组件
/* eslint-disable no-new */
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(Vant);
import i18n from './i18n'

new Vue({
  el: '#app',
  router,
  i18n,
  store,//挂载vuex
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js